<div class="appLogo pointer gap" fxFlex="100" fxLayoutAlign="center center">

    @if (type=='dark') {
    <div>
        <span (click)="closeMenu()">
            <img [alt]="sitename" class="isa" fxFlex="100" fxLayoutAlign="center center"
                [defaultImage]="'assets/images/loading-placeholder.png'" [lazyLoad]="serverPath + 'logo.png'"
                [errorImage]="'assets/images/error/logoerror1.png'" loading="lazy" width="110" height="150" />
        </span>
    </div>
    } @else {
    <span (click)="closeMenu()">
        <!-- <img [alt]="sitename" class="isa" fxFlex="100" fxLayoutAlign="center center" [defaultImage]="defaultImage"
            width="110" height="150" loading="lazy" [src]="serverPath+'logoBG.png'"
            onerror="this.src='assets/images/error/logoerror1.png';this.style.width='80px';" /> -->
            <img [alt]="sitename" class="isa" fxFlex="100" fxLayoutAlign="center center"
                [defaultImage]="'assets/images/loading-placeholder.png'" [lazyLoad]="serverPath+'logoBG.png'"
                [errorImage]="'assets/images/error/logoerror1.png'" loading="lazy" width="110" height="150" />
    </span>
    }



</div>